<script lang="ts">	
	export let data;

	const { generalSettings } = data;
</script>

<svelte:head>
	<title>GDPR - {generalSettings?.shopName}</title>
	<meta name="description" content="GDPR - Zásady ochrany osobních údajů" />
</svelte:head>

<section class="max-w-screen-xl px-4 py-16 mx-auto mb-10 rounded-lg bg-stone-100">
	<h1
		class="mb-10 text-4xl font-extrabold tracking-tight text-center text-gray-900 animate__animated animate__rubberBand">
		GDPR - Zásady ochrany osobních údajů
	</h1>
	<div class="max-w-4xl pb-2 mx-auto">
		<div
			class="grid grid-cols-1 p-5 bg-white border rounded-lg md:grid-cols-1">
				<div class="mb-4 ">
					<p>
						Správce osobních údajů Šťastné srdce s.r.o., Potoční 16, Mikulovice 79084
						(dále jen „správce"), prohlašuje, že veškeré osobní údaje
						zpracovávané správcem jsou přísně důvěrné. Správce s nimi nakládá v
						souladu s vnitrostátními právními předpisy i předpisy Evropské unie
						platnými v oblasti ochrany osobních údajů.
					</p>
					<br />
					<p>
						Správce shromažďuje, uchovává a využívá Vaše osobní údaje ve smyslu
						zákona č. 110/2019 Sb. o zpracování osobních údajů (dále jen zákon o
						zpracování osobních údajů), resp. nařízení Evropského parlamentu a
						Rady (EU) 2016/679 ze dne 27. dubna 2016, o ochraně fyzických osob v
						souvislosti se zpracováním osobních údajů a o volném pohybu těchto
						údajů a o zrušení směrnice 95/46/ES (dále jen „nařízení GDPR").
						Jednotlivé účely, pro které správce osobní údaje zpracovává, jsou
						dále vymezeny.
					</p>
					<br />
					<p>
						Správce tyto osobní údaje shromažďuje i prostřednictvím svých
						internetových stránek na adrese www.stastnesrdce.cz (dále jen
						„internetové stránky").
					</p>
					<br />
					<p>
						Tyto zásady vydává správce proto, abyste byli dostatečně informován (a) o tom, jaké Vaše osobní údaje správce zpracovává, za jakým účelem,
						po jakou dobu, kdo k Vašim osobním údajům bude mít přístup a jaká
						máte práva. Tyto zásady se vztahují na všechny osobní údaje
						shromážděné správcem, ať už byly shromážděny za účelem plnění
						smluvního vztahu, právní povinnosti, oprávněného zájmu, nebo
						uděleného souhlasu.
					</p>
					<br />
					<h2 class="text-2xl font-bold text-gray-800 mb-4">Zpracovávané údaje</h2>
					<p>
						Správce je oprávněn zpracovávat následující osobní údaje dle účelu, dle kategorií osobních údajů, dle kategorií subjektu údajů, dle kategorií příjemců a dle doby uchování následovně.
					</p>
					<br>
					<p>
						Jednotlivými účely zpracování se míní následující.
					</p>
					<p>
						a) Plnění smluvního vztahu znamená vztah mezi Vámi a správcem vzniklý na základě: objednávky, uzavřené smlouvy, přihlášky a účasti v soutěži, registrace a podobně.
					</p>
					<p>
						b) Zasílání obchodních sdělení a nabídka produktů a služeb znamená zasílání obchodních nabídek, a to prostřednictvím: elektronické pošty (e-mailem), prostřednictvím krátkých textových zpráv nebo prostřednictvím telefonního hovoru.
					</p>
					<p>
						c) Účetní a daňové účely: evidence účetnictví ve smyslu účetní a daňové legislativy.
					</p>
					<p>
						d) Personální a mzdová agenda: uzavírání pracovních smluv, zpracování mezd, odvody sociálního a zdravotního pojištění podle zákona č. 262/2006 Sb., zákoník práce, č. 582/1991 Sb. o organizaci a provádění sociálního zabezpečení, č. 48/1997 Sb., o veřejném zdravotním pojištění a o změně a doplnění některých souvisejících zákonů.
					</p>
					<p>
						e) Statistické účely: anonymizované zjišťování návštěvnosti internetových stránek, dále monitoring počtu shlédnutí stránek, času stráveného na internetových stránkách, typ zařízení, ze kterého přicházíte na internetové stránky.
					</p>
					<br>
					<p>
						Data sbíráme proto, abychom mohli zkvalitňovat poskytované služby a nabízet klientům relevantní obsah.
						<br>
						Zobrazování reklam znamená zobrazování reklam na internetových stránkách na základě statisticky zjištěných preferencí zákazníka.
						<br>
						Oprávněný zájem znamená účinnou obhajobu v případě sporu. Doba zpracování osobních údajů v takovém případě činí čtyři roky od uplynutí záruční doby na zboží a prodlužuje se o dobu, po kterou je veden spor. Chceme stále zkvalitňovat své služby a případně poskytovat služby nové a lepší. Chceme se bránit maření takové činnosti, proto činnosti, které přispívají k naplnění tohoto cíle, jsou naším oprávněným zájmem. Oprávněným zájmem je také zpracování pro účely zamezení podvodům (např. posuzování rizikovosti uzavření smlouvy), přímý marketing (např. nabízení relevantních služeb stávajícím zákazníkům), předávání osobních údajů v rámci skupiny podniků pro vnitřní administrativní účely, oznámení trestných činů a předání osobních údajů příslušnému orgánu, zajištění bezpečnosti sítě a informací. Tento výčet je pouze příkladný. Plnění dalších zákonných povinností znamená poskytování informací orgánům činným v trestním řízení, poskytování informací jiným orgánům veřejné moci a podobně.
					</p>
					<br />
					<p>
						Vaše osobní údaje zpracováváme po dobu nezbytně nutnou k zajištění
						všech práv a povinností plynoucích ze vzájemného právního jednání, a to minimálně po dobu vyřízení objednávky, provedení obchodu, zařízení služby apod., dále po dobu, kterou je správce povinen osobní údaje
						uchovávat podle obecně závazných právních předpisů nebo po dobu, na
						kterou jste správci případně udělili souhlas. Jinak doba zpracování
						vyplývá z účelu, pro které jsou osobní údaje zpracovávány, nebo je
						dána právními předpisy.
					</p>
					<p>
						Osobní údaje jsou správcem zpracovávány manuálně i automatizovaně.
						Správce je oprávněn zpracovávat některé informace automatizovaně
						například pro vytvoření statistických informací o návštěvnosti svých
						internetových stránek.
					</p>
					<br />
					<h2 class="text-2xl font-bold text-gray-800 mb-4">Osobní údaje zpracovávané na základě souhlasu</h2>
					<p>
						Pokud jsme od Vás získali souhlas ke zpracování osobních údajů,
						stalo se tak pro některý z následujících účelů: Zákazníci, Shromažďování osobních údajů zaměstnanců zákazníků / zákazníků Správce (jméno, příjmení, adresa bydliště / podnikání, IČ, DIČ, kontaktní a další údaje nezbytné k uzavření smluvního vztahu a souvisejících evidencí), zaznamenání, ukládání těchto údajů na nosiče informací, používání, třídění nebo kombinování, zpřístupnění přenosem, blokování a likvidace údajů s využitím manuálních prostředků.
					</p>
					<br>
					<p>
						Účel zpracování: Splnění smlouvy, jejíž smluvní stranou je subjekt údajů. Plnění zákonných povinností Správce vyplývajících ze zvláštních předpisů.
					</p>
					<br>
					<p>
						Dodavatelé Shromažďování osobních údajů dodavatelů (OSVČ) Správce (jméno, příjmení, adresa bydliště / podnikání, IČ, DIČ, kontaktní a další údaje nezbytné k uzavření smluvního vztahu a souvisejících evidencí), zaznamenání, ukládání těchto údajů na nosiče informací, používání, třídění nebo kombinování, zpřístupnění přenosem, blokování a likvidace údajů s využitím manuálních prostředků. Účelem zpracování je splnění smlouvy, jejíž smluvní stranou je subjekt údajů Plnění zákonných povinností Správce vyplývajících ze zvláštních předpisů (jmenovitě zák. o DPH v pl. zn., a dalších) Jiné kategorie subjektů údajů Externí zpracovatel ve smyslu GDPR není využíván. Osobní údaje nejsou předávány do třetích zemí nebo mezinárodních organizací.
					</p>
					<br />
					<h2 class="text-2xl font-bold text-gray-800 mb-4">Práva subjektu údajů</h2>
					<p>
						Jako subjekt údajů máte uvedená práva, která pro Vás z právních
						předpisů vyplývají a která můžete kdykoliv uplatnit. Jedná se o:
						právo na přístup k osobním údajům, podle kterého máte právo získat
						od správce informace o tom, jestli správce zpracovává Vaše osobní
						údaje. Tuto informaci je správce povinen Vám bez zbytečného odkladu
						předat. Obsah informace je dán ustanovením článku 15 nařízení GDPR.
						Správce má právo za poskytnutí informace požadovat přiměřenou úhradu
						nepřevyšující náklady nezbytné na poskytnutí informace; právo na
						opravu nebo výmaz osobních údajů, popřípadě omezení zpracování,
						podle kterého máte právo na to, nechat opravit osobní údaje, které
						jsou nepřesné nebo nesprávné. Pokud již Vaše osobní údaje nejsou
						potřebné pro účely, ke kterým byly shromážděny, nebo jsou
						zpracovávány protiprávně, máte právo požadovat jejich výmaz. Pokud
						nechcete žádat výmaz osobních údajů, ale pouze dočasně omezit jejich
						zpracování, můžete žádat omezení zpracování; právo požadovat
						vysvětlení v případě, že máte podezření, že zpracování osobních
						údajů správcem je v rozporu s právními předpisy; právo obrátit se na
						Úřad pro ochranu osobních údajů v případě pochybností o dodržování
						povinností souvisejících se zpracováním osobních údajů; právo na
						přenositelnost údajů, tj. právo získat osobní údaje, které se Vás
						týkají, které jste poskytl správci, ve strukturovaném, běžně
						používaném a strojově čitelném formátu, blíže viz. čl. 20 GDPR;
						právo vznést námitku proti zpracování osobních údajů, které jsou
						zpracovávány pro účely splnění úkolu prováděného ve veřejném zájmu
						nebo při výkonu veřejné moci nebo pro účely ochrany oprávněných
						zájmů správce. Správce zpracování ukončí bez zbytečného odkladu, pokud neprokáže, že existuje oprávněný zájem/důvod pro zpracování, který převažuje nad Vaším zájmem, právy nebo svobodami; právo
						souhlas se zpracováním osobních údajů kdykoliv odvolat, pokud jste
						udělili správci souhlas se zpracováním osobních údajů.
					</p>
					<br />
					<h2 class="text-2xl font-bold text-gray-800 mb-4">Cookies</h2>
					<p>
						Soubory cookies jsou krátké textové soubory, které internetová
						stránka odešle do Vašeho prohlížeče. Umožňují internetové stránce
						zaznamenat informace o Vaší návštěvě, například zvolený jazyk a
						podobně. Následující návštěva stránek tak pro Vás může být snazší a příjemnější. Soubory cookies jsou důležité, neboť bez nich by
						procházení sítě Internet bylo mnohem složitější. Soubory cookies
						umožňují lepší využití naší internetové stránky a přizpůsobení
						jejího obsahu Vašim potřebám. Používá je téměř každá internetová
						stránka na světě. Soubory cookies jsou užitečné, protože zvyšují
						uživatelskou přívětivost opakovaně navštívené internetové stránky.
					</p>
					<br>
					<p>
						Na internetových stránkách správce může využívat tyto druhy cookies:
					</p>
					<p>
						a) Relační (tedy dočasné) soubory cookies nám umožňují propojovat Vaše
						jednotlivé aktivity po dobu prohlížení těchto internetových stránek.
						V okamžiku otevření okna Vašeho prohlížeče se tyto soubory aktivují
						a deaktivují se po zavření okna Vašeho prohlížeče. Relační cookies
						jsou dočasné a po zavření prohlížeče se všechny tyto soubory
						vymažou.
					</p>
					<p>
						b) Trvalé soubory cookies nám pomáhají Váš počítač
						identifikovat, jestliže opětovně navštívíte naši internetovou
						stránku. Další výhodou trvalých cookies je to, že nám umožňují
						přizpůsobit naše internetové stránky Vašim potřebám.
					</p>
					<br>
					<p>
						V souladu s ustanovením § 89 odst. 3 zák. č. 127/2005 Sb., o
						elektronických komunikacích, v účinném znění, si Vás tímto
						dovolujeme informovat, že naše internetové stránky využívají pro
						svoji činnost soubory cookies, tedy že Vaše soubory cookies, včetně
						trvalých, zpracováváme.
					</p>
					<br>
					<p>
						Internetové prohlížeče obvykle obsahují správu souborů cookies. V
						rámci nastavení Vašeho prohlížeče tak pravděpodobně můžete
						jednotlivé soubory cookies ručně mazat, blokovat či zcela zakázat
						jejich používání. Pro více informací použijte nápovědu svého
						internetového prohlížeče. Pokud použití souborů cookies nepovolíte,
						některé funkce a stránky nemusí fungovat, jak by měly.
					</p>
					<br>
					<p>
						K personalizaci obsahu a reklam, poskytování funkcí sociálních médií
						a analýze naší návštěvnosti využíváme soubory cookies. Informace o
						tom, jak náš web používáte, sdílíme se svými partnery působícími v
						oblasti sociálních médií, inzerce a analýz. Používáním internetových
						stránek vyjadřujete souhlas propojením následujících služeb:
						neshromažďujeme
					</p>
					<br />
					<p>
						Kvůli zobrazení cílené reklamy v rámci reklamních a sociálních sítí
						na jiných internetových stránkách předáváme těmto reklamním a
						sociálním sítím údaje o vašem chování na webu; nepředáváme jim však
						vaše identifikační údaje.
					</p>
					<br />
					<p>
						Další informace o právech a povinnostech při ochraně osobních údajů
						může subjekt údajů získat na webových stránkách www.stastnesrdce.cz
						nebo prostřednictvím e-mailu na stastnesrdce@seznam.cz
					</p>
				</div>
			</div>
		</div>
</section>